import React from 'react'
import { IconsModel } from './types/iconsModel'

const SvgPlus = (
	{
		color,
		width = 62,
		height = 62,
		...props
	}: IconsModel
) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 62 62" {...props}>
		<g data-name="Groupe 320">
			<g
				data-name="Ellipse 43"
				transform="rotate(-90 31 31)"
				fill="none"
				stroke={color}
				strokeWidth={4}
			>
				<circle cx={31} cy={31} r={31} stroke="none" />
				<circle cx={31} cy={31} r={29} />
			</g>
			<g data-name="Groupe 190">
				<path
					data-name="Ligne 28"
					fill="none"
					stroke={color}
					strokeWidth={4}
					d="M41.284 31.132H20.628"
				/>
			</g>
			<g data-name="Groupe 302">
				<path
					data-name="Ligne 28"
					fill="none"
					stroke={color}
					strokeWidth={4}
					d="M30.956 41.458V20.802"
				/>
			</g>
		</g>
	</svg>
)

export default SvgPlus